import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import "./styles.css";

export const STEPS = [
  {
    id: "PROPERTY",
    label: "Setup Property",
  },
  {
    id: "LEASE",
    label: "Lease Settings",
    disabled: true,
  },
  {
    id: "UNITS",
    label: "Units",
    disabled: true,
  },
  {
    id: "UNITS_LEASE",
    label: "Units Lease Settings ",
    disabled: true,
  },
];

export default function Stepper({ currentStepIndex, id, unitid = 0 }) {
  const history = useHistory();
  const onClick = (index) => {
    switch (index) {
      case 0:
        history.push(`/add-property/${id}`);
        break;
      case 1:
        history.push(`/add-property/${id}/lease`);
        break;
      case 2:
        history.push(`/add-property/${id}/unit/${unitid}`);
        break;
      default:
        break;
    }
  };
  return (
    <ul id="sidebar">
      {STEPS.map((step, index) => (
        <li key={index}>
          <Button
            variant="text"
            onClick={() => onClick(index)}
            disabled={currentStepIndex <= index}
            key={index}
            className={`sidebar-button ${
              currentStepIndex === index ? "active" : ""
            }`}
          >
            {index + 1}.{step.label}
          </Button>
        </li>
      ))}
    </ul>
  );
}
